<template>
    <div class="t-lk-main">
        <h1 class="visually-hidden">{{ $root.staticText.lk.title }}</h1>
        <div class="t-lk-container">
            <div class="t-lk-main__container">
                <div class="t-lk-main__left">
                    <div v-if="notifications && notifications.length > 0" v-animation:bottom.delay class="t-lk-main-block">
                        <div class="t-lk-main-block__title">{{ $root.staticText.lk.mainNotification }}</div>
                        <a :href="item.link" v-for="item in notifications" class="t-lk-main-block__item">
                            <span class="t-lk-main-block__text">{{ item.text }}</span>
                        </a>
                    </div>
                    <div v-if="priceList && priceList.length > 0" v-animation:bottom.delay class="t-lk-main-block _white">
                        <div class="t-lk-main-block__title">{{ $root.staticText.lk.mainPriceList }}</div>
                        <a :href="item.document" download v-for="item in priceList" class="t-lk-main-block__item">
                            <span class="t-lk-main-block__text">{{ item.text }}</span>
                            <div class="t-lk-main-block__date">{{ item.date }}</div>
                            <svg class="t-lk-main-block__svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.50004 11.8335C2.86823 11.8335 3.16671 12.132 3.16671 12.5002V15.8335C3.16671 16.0987 3.27206 16.3531 3.4596 16.5406C3.64714 16.7281 3.90149 16.8335 4.16671 16.8335H15.8334C16.0986 16.8335 16.3529 16.7281 16.5405 16.5406C16.728 16.3531 16.8334 16.0987 16.8334 15.8335V12.5002C16.8334 12.132 17.1319 11.8335 17.5 11.8335C17.8682 11.8335 18.1667 12.132 18.1667 12.5002V15.8335C18.1667 16.4523 17.9209 17.0458 17.4833 17.4834C17.0457 17.921 16.4522 18.1668 15.8334 18.1668H4.16671C3.54787 18.1668 2.95438 17.921 2.51679 17.4834C2.07921 17.0458 1.83337 16.4523 1.83337 15.8335V12.5002C1.83337 12.132 2.13185 11.8335 2.50004 11.8335Z" fill="#00b0bd"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.36189 7.86177C5.62224 7.60142 6.04435 7.60142 6.3047 7.86177L9.99996 11.557L13.6952 7.86177C13.9556 7.60142 14.3777 7.60142 14.638 7.86177C14.8984 8.12212 14.8984 8.54423 14.638 8.80458L10.4714 12.9712C10.211 13.2316 9.7889 13.2316 9.52855 12.9712L5.36189 8.80458C5.10154 8.54423 5.10154 8.12212 5.36189 7.86177Z" fill="#00b0bd"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.8335C10.3682 1.8335 10.6667 2.13197 10.6667 2.50016V12.5002C10.6667 12.8684 10.3682 13.1668 10 13.1668C9.63185 13.1668 9.33337 12.8684 9.33337 12.5002V2.50016C9.33337 2.13197 9.63185 1.8335 10 1.8335Z" fill="#00b0bd"/>
                            </svg>
                        </a>
                    </div>
                    <p
                        v-if="(notifications && notifications.length === 0) && (priceList && priceList.length === 0)"
                        v-animation:bottom.delay
                        class="t-lk-main__not t-lk-container-mobile t-lk-services-item__text"
                    >
                        {{ $root.staticText.lk.mainNotifyNot }}
                    </p>
                </div>
                <div class="t-lk-main__right">
                    <lk-title-link-cmp
                        v-animation:bottom.delay
                        :title="$root.staticText.lk.mainServiceTitle"
                        :link="'/lk/services'"
                        :name="$root.staticText.lk.mainServiceAll"
                    ></lk-title-link-cmp>
                    <div class="t-lk-main-services">
                        <lk-services-item-cmp
                            v-animation:bottom.delay
                            :key="'services-item-00'"
                            :item="{
                                id: 1,
                                img: '/dist/img/service-doc.png',
                                name: $root.staticText.lk.mainDocName,
                                text: $root.staticText.lk.mainDocText,
                                link: linkPdf,
                                isTarget: false,
                                btn: $root.staticText.lk.mainDocBtn
                            }"
                            class="t-lk-main-services__item"
                        >
                        </lk-services-item-cmp>
                        <lk-services-item-cmp
                            v-animation:bottom.delay
                            v-for="(item, index) in services"
                            :key="'services-item' + index"
                            :item="item"
                            class="t-lk-main-services__item"
                        >
                        </lk-services-item-cmp>
                        <banner-native-cmp
                            v-if="bannerServices"
                            v-animation:bottom.delay
                            :banner="bannerServices"
                            class="t-lk-main-services__item t-lk-main__banner"
                        >
                        </banner-native-cmp>
                    </div>
                </div>
            </div>

            <div class="t-lk-main__container">
                <div class="t-lk-main__left">
                    <banner-native-cmp
                        v-if="banner"
                        v-animation:bottom.delay
                        :banner="banner"
                        :is-vertical="true"
                    >
                    </banner-native-cmp>
                </div>
                <div class="t-lk-main__right">
                    <lk-title-link-cmp
                        v-animation:bottom.delay
                        :title="$root.staticText.lk.mainEventsTitle"
                        :link="'/lk/events'"
                        :name="$root.staticText.lk.mainEventsAll"
                    ></lk-title-link-cmp>
                    <div v-if="events && events.length > 0" class="t-lk-main-events">
                        <div v-animation:bottom.delay v-for="(item, index) in events" class="t-lk-events__item">
                            <div class="t-lk-events__left">
                                <div class="t-lk-events__row">
                                    <div class="t-lk-events__category">{{ item.category }}</div>
                                    <div class="t-lk-events__date">{{ item.date }}</div>
                                </div>
                                <div class="t-lk-events__name t-clamp-3">{{ item.name }}</div>
                                <div class="t-lk-events__row">
                                    <div class="t-lk-events__img">
                                        <img v-if="item.img" :src="item.img" alt="">
                                    </div>
                                    <a
                                        v-if="!item.isAdded"
                                        :href="item.ics"
                                        @click="item.isAdded = true"
                                        class="t-lk-events__add t-lk-main-events__add"
                                    >
                                        <template v-if="isTablet || isMobile">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.26676 7.33343V3.6001M15.7334 7.33343V3.6001M7.33343 11.0668H16.6668M10.8001 20.4001H5.46676C4.97169 20.4001 4.4969 20.2034 4.14683 19.8534C3.79676 19.5033 3.6001 19.0285 3.6001 18.5334V7.33343C3.6001 6.83836 3.79676 6.36357 4.14683 6.0135C4.4969 5.66343 4.97169 5.46676 5.46676 5.46676H18.5334C19.0285 5.46676 19.5033 5.66343 19.8534 6.0135C20.2034 6.36357 20.4001 6.83836 20.4001 7.33343V12.0001" stroke="#4D556D" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M17.8657 22.2002V18.1057V14.4002" stroke="#4D556D" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M21.7656 18.2998H17.6711H13.9656" stroke="#4D556D" stroke-width="1.68" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </template>
                                        <template v-else>
                                            {{ $root.staticText.lk.eventsAdd }}
                                        </template>
                                    </a>
                                    <a
                                        v-else
                                        :href="item.ics"
                                        class="t-lk-events__add _delete"
                                        @mouseenter="visibleDelete = index"
                                        @mouseleave="visibleDelete = -1"
                                        @click="item.isAdded = false"
                                    >
                                        <template v-if="isTablet || isMobile">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.26676 7.33343V3.6001M15.7334 7.33343V3.6001M7.33343 11.0668H16.6668M10.8001 20.4001H5.46676C4.97169 20.4001 4.4969 20.2034 4.14683 19.8534C3.79676 19.5033 3.6001 19.0285 3.6001 18.5334V7.33343C3.6001 6.83836 3.79676 6.36357 4.14683 6.0135C4.4969 5.66343 4.97169 5.46676 5.46676 5.46676H18.5334C19.0285 5.46676 19.5033 5.66343 19.8534 6.0135C20.2034 6.36357 20.4001 6.83836 20.4001 7.33343V12.0001" stroke="#D65663" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M19.8 18.6001H17.2803H15" stroke="#D65663" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M17.4 23.2999C19.9957 23.2999 22.0999 21.1956 22.0999 18.5999C22.0999 16.0042 19.9957 13.8999 17.4 13.8999C14.8042 13.8999 12.7 16.0042 12.7 18.5999C12.7 21.1956 14.8042 23.2999 17.4 23.2999Z" stroke="#D65663"/>
                                            </svg>
                                        </template>
                                        <template v-else>
                                            {{ visibleDelete === index ? $root.staticText.lk.eventsDelete : $root.staticText.lk.eventsAdded }}
                                        </template>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        v-animation:bottom.delay
                        class="t-lk-main__not t-lk-container-mobile t-lk-services-item__text"
                    >
                        {{$root.staticText.lk.mainEventsNot}}
                    </div>

                    <lk-title-link-cmp
                        v-animation:bottom.delay
                        :title="$root.staticText.lk.mainPromotionsTitle"
                        :link="'/lk/promotions'"
                        :name="$root.staticText.lk.mainPromotionsAll"
                    ></lk-title-link-cmp>
                    <div v-if="promotions && promotions.length > 0" class="t-lk-main-promotions">
                        <div
                            v-animation:bottom.delay
                            v-for="item in promotions"
                            class="t-lk-promotions-selection__item"
                        >
                            <div class="t-lk-promotions__row t-lk-main-promotions__row">
                                <div class="t-lk-promotions-selection__desc" v-html="item.description"></div>
                                <div class="t-lk-promotions__date">{{ item.date }}</div>
                            </div>
                            <div class="t-lk-promotions__row">
                                <div class="t-lk-promotions__img">
                                    <img v-if="item.img" :src="item.img" :alt="item.name">
                                </div>
                                <div class="t-lk-promotions__status">
                                    <div v-if="item.status" class="t-lk-promotions__text" v-html="item.status"></div>
                                    <div v-if="item.status && item.progress" class="t-lk-promotions__progress">
                                        <span :style="'width: ' + item.progress + '%;'"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-else
                        v-animation:bottom.delay
                        class="t-lk-main__not t-lk-container-mobile t-lk-services-item__text"
                    >
                        {{$root.staticText.lk.mainPromotionsNot}}
                    </div>

<!--                    <lk-title-link-cmp-->
<!--                        v-animation:bottom.delay-->
<!--                        :title="$root.staticText.lk.mainLeadsTitle"-->
<!--                        :link="'/lk/leads'"-->
<!--                        :name="$root.staticText.lk.mainLeadsAll"-->
<!--                    ></lk-title-link-cmp>-->
<!--                    <div v-if="leads && leads.length > 0" class="t-lk-main-leads">-->
<!--                        <div-->
<!--                            v-animation:bottom.delay-->
<!--                            class="t-lk-main-leads__item"-->
<!--                            v-for="item in leads"-->
<!--                            :class="{_border: !item.isChangeStatus}"-->
<!--                        >-->
<!--                            <div class="t-lk-main-leads__top">-->
<!--                                <div class="t-lk-main-leads__name">{{ item.name }}</div>-->
<!--                                <div class="t-lk-main-leads__date">{{ item.date }}</div>-->
<!--                            </div>-->
<!--                            <div class="t-lk-main-leads__row" v-for="listItem in item.list">-->
<!--                                <div class="t-lk-main-leads__subtitle">{{ listItem.name }}</div>-->
<!--                                <div class="t-lk-main-leads__value">{{ listItem.value }}</div>-->
<!--                            </div>-->
<!--                            <div class="t-lk-main-leads__bottom">-->
<!--                                <template v-if="!item.isChangeStatus">-->
<!--                                    <div class="t-lk-main-leads__accept">{{ $root.staticText.lk.leadsAccept }}</div>-->
<!--                                    <div class="t-lk-main-leads__cancel">{{ $root.staticText.lk.leadsCancel }}</div>-->
<!--                                </template>-->
<!--                                <div v-else class="t-lk-main-leads__accept">{{ $root.staticText.lk.leadsChange }}</div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div-->
<!--                        v-else-->
<!--                        v-animation:bottom.delay-->
<!--                        class="t-lk-main__not t-lk-container-mobile t-lk-services-item__text"-->
<!--                    >-->
<!--                        {{$root.staticText.lk.mainLeadsNot}}-->
<!--                    </div>-->

                </div>
            </div>

            <div class="t-lk-main-competencies">
                <lk-title-link-cmp
                    v-animation:bottom.delay
                    :title="$root.staticText.lk.mainCompetenciesTitle"
                    :link="'/lk/competencies'"
                    :name="$root.staticText.lk.mainCompetenciesAll"
                ></lk-title-link-cmp>
                <div class="t-lk-main-competencies__container">
                    <lk-competencies-item-cmp
                        v-for="(item, index) in competencies"
                        :item="item"
                        :key="'lk-main-competencies-item-' + index"
                        :currencies="currencies"
                    >
                    </lk-competencies-item-cmp>
                    <router-link
                        :to="{name: 'lk-competencies', params: {scroll: true}}"
                        v-animation:bottom.delay
                        class="t-lk-competencies-item _last"
                    >
                        {{ $root.staticText.lk.mainAdd }}
                    </router-link>
                </div>
            </div>

            <div v-if="communities && communities.length > 0" class="t-lk-main-communities">
                <div v-animation:bottom.delay class="t-lk-promotions__row">
                    <h1 class="t-lk-title t-lk-promotions__title t-lk-container-mobile">
                        {{ $root.staticText.lk.mainCommunitiesTitle }}
                    </h1>
                </div>
                <div class="t-lk-main-communities__container">
                    <div v-animation:bottom.delay v-for="item in communities" class="t-lk-main-communities__item">
                        <div class="t-lk-main-communities__point"></div>
                        <div v-if="item.img" class="t-lk-main-communities__img">
                            <img :src="item.img" alt="">
                        </div>
                        <div v-else-if="item.title" class="t-lk-main-communities__title">{{ item.title }}</div>
                        <div class="t-lk-main-communities__subtitle">{{ $root.staticText.lk.mainCommunities }}</div>
                        <div class="t-lk-main-communities__name">{{ item.name }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import titleLink from '@components/lk/lk-title-link/lk-title-link.vue';
    import servicesItem from '@components/lk/lk-services-item/lk-services-item.vue';
    import bannerNative from '@components/lk/banner-native/banner-native.vue';
    import competenciesItem from '@components/lk/lk-competencies-item/lk-competencies-item.vue'
    import { mapState } from "vuex";
    import {router} from "@src/routes";

    export default {
        name: "lk-main",
        data() {
            return {
                visibleDelete: false,

                notifications: [],
                priceList: [],
                linkPdf: '',
                services: [],
                bannerServices: null,
                banner: null,
                events: [],
                promotions: [],
                leads: [],
                competencies: [],
                currencies: [],
                communities: [],
            }
        },
        components: {
            'lk-title-link-cmp': titleLink,
            'lk-services-item-cmp': servicesItem,
            'banner-native-cmp': bannerNative,
            'lk-competencies-item-cmp': competenciesItem,
        },
        computed: {
            ...mapState('mobile', ['isMobile', 'isTablet']),
        },
        methods: {
            setData(data) {
                this.notifications = data.notifications;
                this.priceList = data.priceList;
                this.linkPdf = data.linkPdf;
                this.services = data.services;
                this.bannerServices = data.bannerServices;
                this.banner = data.banner;
                this.events = data.events;
                this.promotions = data.promotions;
                this.leads = data.leads;
                this.competencies = data.competencies;
                this.currencies = data.currencies;
                this.communities = data.communities;
            },
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/mainPage.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/main/index.vue